/* Balamb Studios — split hero interactivity helper.
   Adds a 'touch' fallback for mobile stacking and a reveal observer. */
(function () {
  var IS_TOUCH = matchMedia('(hover: none)').matches;

  // Reveal on scroll
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.15 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }

  // Ensure panes are clickable (scroll to target) and keyboard accessible
  document.querySelectorAll('.split-hero__pane').forEach(function (pane) {
    pane.setAttribute('role', 'button');
    pane.setAttribute('tabindex', '0');

    pane.addEventListener('click', function () {
      var tgt = pane.getAttribute('data-target');
      if (!tgt) return;
      if (tgt.charAt(0) === '#') {
        var node = document.querySelector(tgt);
        if (node) node.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.location.href = tgt;
      }
    });

    pane.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pane.click(); }
    });
  });

  // On touch devices, remove the hover-driven flex-grow behaviour (already via media query)
  if (IS_TOUCH) { document.documentElement.classList.add('is-touch'); }

  // Live status indicator for hover
  var status = document.querySelector('[data-hero-status]');
  if (status) {
    document.querySelectorAll('.split-hero__pane').forEach(function (pane) {
      pane.addEventListener('mouseenter', function () {
        var label = pane.getAttribute('data-status-label') || '';
        status.textContent = label;
      });
      pane.addEventListener('mouseleave', function () {
        status.textContent = status.getAttribute('data-default') || '';
      });
    });
  }
})();
